import { calcularDiferenciaDeTiempo, calcularSegundosHoraSeleccionada, calcularTiempoMaxLimite, convertirHoraIntervalo30Minutos, esFechaHoraFutura, formatDate, handleAxiosError, horaActualSistema, horaToNumero, texto, verificarHoras } from '@/shared';
import { getCache, postCache, postHorasDisponiblesFlota, postPlanificadorTimeMaps, putPlanificationBlock, unblockManyHours } from '@/shared/actions/erp';
import { AlertSeverityEnum, ICalendarioProps, TiempoBloqueoENUM, } from '@/shared/interfaces';
import { IFechasDisponible, IHorasDisponibles } from '@/shared/interfaces/erp/system-settings/horas-libres-flota.interface';
import { useAuthStore } from '@/store/auth';
import { useUiStore } from '@/store/ui';
import { NavigateFunction } from 'react-router-dom';
import { create } from 'zustand';

type IDataPreseleccionada = {
  razon_social: string;
  identificacion: string;
  fecha_hora_instalacion: string;
  celular: string;
  estado_aceptacion: string;
}
interface ICalendarioInstalacionPyl {

  dataPreseleccionada: IDataPreseleccionada | null;
  setDataPreseleccionada: (dataPreseleccionada: IDataPreseleccionada | null) => void;

  isVisibleCalendario: boolean;
  setIsVisibleCalendario: (isVisibleCalendario: boolean) => void;

  //cambioFechaInstalacion: boolean;
  //setCambioFechaInstalacion: (cambioFechaInstalacion: boolean) => void;

  horasSelect: number[];
  setHoraSelect: (horasSelect: number[]) => void;

  currentIndex: number;
  setCurrentIndex: (currentIndex: number) => void;

  isLoadingPlanificacion: boolean;
  setIsLoadingPlanificacion: (isLoadingPlanificacion: boolean) => void;

  minDate: string | null;
  setMinDate: (minDate: string) => void;

  maxDate: string | null;
  setMaxDate: (maxDate: string) => void;

  modal: boolean;
  setModal: (modal: boolean) => void;

  modalPreseleccionada: boolean;
  setModalPreseleccionada: (modalPreseleccionada: boolean) => void;

  idPreventa: string | null;
  setIdPreventa: (idPreventa: string | null) => void;

  bloquear: boolean;
  setBloquear: (bloquear: boolean) => void;

  countdown: number;
  setCountdown: (segundos: number) => void;

  clickedIdHora: string | null;
  setClickedIdHora: (clickedIdHora: string | null, cacheKey: string) => void;

  fechaHoraDisponible: IFechasDisponible[] | null;
  setFechaHoraDisponible: (fechaHoraDisponible: IFechasDisponible[] | null) => void;

  horasDisponibles: IHorasDisponibles[];
  setHorasDisponibles: (horasDisponibles: IHorasDisponibles[]) => void;

  codigoFlota: string | null;
  setCodigoFlota: (codigoFlota: string | null) => void;

  fechaSelecionada: string | null;
  setFechaSelecionada: (fechaSelecionada: string) => void;

  countdownInterval: NodeJS.Timeout | null;
  setCountdownInterval: () => void;

  countdownTimeOut: NodeJS.Timeout | null;
  setCountdownTimeOut: (milisegundos: number, cacheKey: string, desbloquear?: boolean, alerta?: boolean) => void;

  /* setAux: (aux: boolean) => void;
  aux: boolean; */

  handleVerificarCache: (key: string, codigoFlota: string, idPreventa: string, cacheKey: string, navigate?: NavigateFunction) => Promise<ICalendarioProps | null>;
  handleRecargarHoras: () => void;
  handleFechaCalendario: (fecha: string) => boolean;
  handleVerificarHoraSeleccionada: (hora: number) => void;
  handleObtenerPlanificacion: (codigoFlota: string, fecha: string) => void;
  handleValidarFechaVendedor: (fecha_instalacion: string, hora_instalacion: string, flota: string) => Promise<boolean>;

}


const useCalendarioInstalacionPyl = create<ICalendarioInstalacionPyl>((set, get) => ({
  async handleValidarFechaVendedor(fecha_instalacion, hora_instalacion, flota) {


    const setAlert = useUiStore.getState().setAlert;

    if (get().bloquear) return true;

    if (!esFechaHoraFutura(fecha_instalacion, hora_instalacion)) {
      setAlert(true, 'La fecha asignada es una fecha anterior a la actual.', AlertSeverityEnum.info);
      return false;
    }

    const resp = await postPlanificadorTimeMaps({
      fecha: fecha_instalacion,
      flota: flota,
      limite: 1
    })

    if (resp.data.length == 0) {
      setAlert(true, 'No hay planificador para la fecha asignada [404].', AlertSeverityEnum.info);
      return false;

    }

    const fecha = resp.data.find(e => e.fecha == fecha_instalacion);
    if (!fecha) {
      setAlert(true, 'No se encontro planificación para la fecha indicada.', AlertSeverityEnum.info);
      return false;

    }

    const hora = fecha.horas.some(e => e.hora == horaToNumero(hora_instalacion!))

    if (!hora) {
      setAlert(true, 'La fecha y hora asignada se encuentra ocupada. Por favor, selecciona otra disponible.', AlertSeverityEnum.info);
      return false;

    }

    return true

  },
  dataPreseleccionada: null,
  setDataPreseleccionada(dataPreseleccionada) {
    set({ dataPreseleccionada })
  },

  modalPreseleccionada: false,
  setModalPreseleccionada(modalPreseleccionada) {
    set({ modalPreseleccionada })
  },

  isVisibleCalendario: false,
  setIsVisibleCalendario(isVisibleCalendario) {
    set({ isVisibleCalendario })
  },

  /* cambioFechaInstalacion: false,
  setCambioFechaInstalacion(cambioFechaInstalacion) {
    set({ cambioFechaInstalacion })
  }, */

  horasSelect: [],
  setHoraSelect: (horasSelect) => {
    set({ horasSelect })
  },

  currentIndex: 0,
  setCurrentIndex(currentIndex) {
    set({ currentIndex })
  },

  isLoadingPlanificacion: false,
  setIsLoadingPlanificacion(isLoadingPlanificacion) {
    set({ isLoadingPlanificacion })
  },
  minDate: null,
  setMinDate(minDate) {
    set({ minDate })
  },

  maxDate: null,
  setMaxDate(maxDate) {
    set({ maxDate })
  },

  modal: false,
  setModal(modal) {
    set({ modal })
  },

  idPreventa: null,
  setIdPreventa(idPreventa) {
    set({ idPreventa })
  },

  bloquear: false,
  setBloquear(bloquearCalendario) {
    set({ bloquear: bloquearCalendario });
  },
  countdownTimeOut: null,
  async setCountdownTimeOut(milisegundos, cacheKey, desbloquear = false, alerta = false) {

    const setAlert = useUiStore.getState().setAlert;

    const { countdownTimeOut,
      countdownInterval,
      fechaSelecionada,
      codigoFlota,
      idPreventa,
      horasSelect,
      clickedIdHora
    } = useCalendarioInstalacionPyl.getState();

    const timeOut = setTimeout(async () => {

      if (desbloquear && clickedIdHora) {

        await unblockManyHours({
          fecha: fechaSelecionada!,
          flota: codigoFlota!,
          horas: horasSelect,
        })
        //set({ fechaHoraDisponible: null })
      }

      await postCache({
        key: `${cacheKey}${idPreventa}`,
        value: null,
      });

      if (alerta) setAlert(true, 'Tiempo terminado.', AlertSeverityEnum.info);

      set({ codigoFlota: '' });
      set({ bloquear: false })
      set({ horasSelect: [] })
      set({ horasDisponibles: [] })
      set({ countdown: TiempoBloqueoENUM.COUNTDOWNINTERVAL_PYL })
      set({ clickedIdHora: null })
      set({ countdownTimeOut: null });
      //set({ cambioFechaInstalacion: false });
      set({ isVisibleCalendario: false })

      if (countdownTimeOut) {
        clearTimeout(countdownTimeOut)
      }

      if (countdownInterval) {
        clearTimeout(countdownInterval)
      }

    }, milisegundos);


    set({ countdownTimeOut: timeOut })

  },
  countdownInterval: null,
  setCountdownInterval: () => {
    const countdownInterval = setInterval(() => {
      set((state) => ({
        countdown: state.countdown - 1
      }));
    }, 1000);

    set({ countdownInterval });
  },
  countdown: TiempoBloqueoENUM.COUNTDOWNINTERVAL_PYL,
  setCountdown(countdown) {
    set({ countdown })
  },

  clickedIdHora: null,
  async setClickedIdHora(value, cacheKey) {
    const { setCountdownInterval,
      setCountdownTimeOut,
      fechaSelecionada,
      codigoFlota,
      idPreventa,
      clickedIdHora,
      currentIndex,
      horasSelect,
    } = useCalendarioInstalacionPyl.getState();

    const user = useAuthStore.getState().user;

    if (clickedIdHora != null) return;

    const hora = value?.replace('id-', '');

    let resp;
    try {
      resp = await putPlanificationBlock({
        fecha: fechaSelecionada!,
        flota: codigoFlota!,
        horas: horasSelect,
        id_preventa: idPreventa!,
        forzar: true,
        tiempo: '00:01',
        motivo: 'BLOQUEADO POR PYL',
      })
    } catch (error) {
      handleAxiosError(error);
      set({ modal: false });
      return;
    }

    if (resp.code !== 200) return;

    const jsonCache: ICalendarioProps = {
      horasSelect: horasSelect,
      valor_hora: +hora!,
      hora_limite: calcularTiempoMaxLimite(1),
      id_user: user?.id,
      id_hora: value!,
      codigo_flota: codigoFlota!,
      id_preventa: idPreventa!,
      fecha_selecionada: fechaSelecionada!,
      numero_tecnico: currentIndex
    };

    await postCache({
      key: `${cacheKey}${idPreventa}`,
      value: jsonCache
    });

    set({ bloquear: true })
    set({ clickedIdHora: value })
    setCountdownInterval()
    setCountdownTimeOut(TiempoBloqueoENUM.COUNTDOWNTIMEOUT_PYL, cacheKey, true, true)
  },
  horasDisponibles: [],
  setHorasDisponibles(horasDisponibles) {
    set({ horasDisponibles })
  },

  fechaHoraDisponible: [],
  setFechaHoraDisponible: (fechaHoraDisponible) => {
    set({ fechaHoraDisponible })
  },

  codigoFlota: '',
  setCodigoFlota: (codigoFlota) => {
    set({ codigoFlota })
  },

  //fechaSelecionada: formatDate(new Date()),
  fechaSelecionada: null,
  setFechaSelecionada: (fechaSelecionada) => {
    const { fechaHoraDisponible } = useCalendarioInstalacionPyl.getState();
    const listaHoraAux = fechaHoraDisponible!.find(e => e.fecha == fechaSelecionada)?.horas;
    set({ fechaSelecionada });

    if (fechaSelecionada == formatDate(new Date)) {
      const newHorasDisponibles = listaHoraAux?.filter(e => e.hora > convertirHoraIntervalo30Minutos());
      set({ horasDisponibles: newHorasDisponibles });
      return;
    }
    set({ horasDisponibles: listaHoraAux })

  },

  handleObtenerPlanificacion: async (codigoFlota, fecha) => {

    const setAlert = useUiStore.getState().setAlert;

    set({ isLoadingPlanificacion: true })
    set({ codigoFlota });

    ///* Limpiar datos al cambiar de flota
    set({ maxDate: null });
    set({ minDate: null });
    set({ fechaSelecionada: null });
    set({ fechaHoraDisponible: [] });
    set({ horasDisponibles: [] });
    set({ horasSelect: [] })

    try {
      ///* Obtener nuevo datos de planificacion
      const respFlota = await postHorasDisponiblesFlota({
        flota: codigoFlota,
        limite: 6,
        incluir_expirados: true
      });

      const dataFlota = respFlota.data;
      const firstElement = dataFlota.at(0);
      const fechaHoraActual = dataFlota.find(e => e.fecha == fecha);

      if (dataFlota.length === 0)
        return setAlert(true, texto.flota_sin_planificacion, AlertSeverityEnum.warning);

      set({ minDate: firstElement?.fecha })
      set({ maxDate: dataFlota.at(dataFlota.length - 1)?.fecha })
      set({ fechaSelecionada: fechaHoraActual?.fecha })
      set({ fechaHoraDisponible: dataFlota });

      //set({ horasDisponibles: fechaHoraActual?.horas })

      get().setFechaSelecionada(fechaHoraActual?.fecha!);

      //set({ horasDisponibles: firstElement?.horas })
      //set({ aux: true });

    } catch (error) {

      set({ fechaHoraDisponible: null })
      //setAlert(true, 'No se ha encontrado una planificación para el técnico seleccionado.', AlertSeverityEnum.warning);

    } finally {
      set({ isLoadingPlanificacion: false })
    }


  },
  handleVerificarCache: async (key, codigoFlota, idPreventa, cacheKey, _navigate): Promise<ICalendarioProps | null> => {

    try {
      const {
        setCountdownInterval,
        setCountdownTimeOut,

      } = useCalendarioInstalacionPyl.getState();

      set({ idPreventa })

      const resp = await getCache(key)

      console.log(resp);


      if (resp.code != 200) return null; ///* No hay datos en cache

      console.log('data_cache_', resp);

      const respFlota = await postHorasDisponiblesFlota({
        flota: codigoFlota,
        limite: 6,
        incluir_expirados: true
      });
      const dataFlota = respFlota.data;

      set({ codigoFlota });
      set({ fechaHoraDisponible: dataFlota });
      //set({ aux: true });

      const dataCalendario = resp.data as ICalendarioProps;

      //console.log(dataCalendario);

      if (dataCalendario.id_preventa == idPreventa &&
        calcularSegundosHoraSeleccionada(dataCalendario.hora_limite!) > 0
      ) return null;

      const tiempoRestante = calcularDiferenciaDeTiempo(horaActualSistema(), dataCalendario.hora_limite!);

      console.log(tiempoRestante, 'tiempo restante');

      set({ isVisibleCalendario: true })

      set({ minDate: dataFlota.at(0)?.fecha });
      set({ maxDate: dataFlota.at(dataFlota.length - 1)?.fecha });
      set({ fechaHoraDisponible: dataFlota });
      set({ codigoFlota: dataCalendario.codigo_flota });
      set({ horasSelect: dataCalendario.horasSelect })

      set({ fechaSelecionada: dataCalendario.fecha_selecionada });
      set({ clickedIdHora: dataCalendario.id_hora });
      set({ horasDisponibles: dataFlota.find(e => e.fecha === dataCalendario.fecha_selecionada)?.horas ?? [] });
      set({ bloquear: true });
      set({ countdown: tiempoRestante });
      setCountdownInterval();
      setCountdownTimeOut(tiempoRestante * 1000, cacheKey, true, true);

      return dataCalendario;

    } catch (error) {

      throw new Error(`Error ${error}`);
      //set({ fechaHoraDisponible: null });
      //set({ bloquear: true });
      //navigate && navigate(ROUTER_PATHS.ventas.preventasNav);
      //handleAxiosError(error, texto.flota_sin_planificacion, AlertSeverityEnum.warning)
    }

  },
  handleRecargarHoras: async () => {
    const { codigoFlota,
      fechaSelecionada,
    } = useCalendarioInstalacionPyl.getState();
    const respFlota = await postHorasDisponiblesFlota({
      flota: codigoFlota!,
      limite: 6,
      incluir_expirados: true
    });
    const listaHoraAux = respFlota.data.find(e => e.fecha == fechaSelecionada)?.horas;
    set({ fechaHoraDisponible: respFlota.data });

    if (fechaSelecionada == formatDate(new Date)) {
      const newHorasDisponibles = listaHoraAux?.filter(e => e.hora > convertirHoraIntervalo30Minutos());
      set({ horasDisponibles: newHorasDisponibles });
      return;
    }
    set({ horasDisponibles: listaHoraAux })

  },

  handleFechaCalendario: (fecha): boolean => {
    const { fechaHoraDisponible } = useCalendarioInstalacionPyl.getState();

    for (let index = 0; index < fechaHoraDisponible!.length; index++) {
      const element = fechaHoraDisponible![index].fecha;
      const horaVacia = fechaHoraDisponible![index].horas;
      if (fecha == element && horaVacia.length > 0) return false;
    }

    return true;
  },

  handleVerificarHoraSeleccionada: async (hora) => {
    const setAlert = useUiStore.getState().setAlert;
    const {
      fechaSelecionada,
      codigoFlota,
      clickedIdHora,
    } = useCalendarioInstalacionPyl.getState();

    //set({ isLoadingPlanificacion: true })

    try {
      if (clickedIdHora != null) return;

      const respFlota = await postHorasDisponiblesFlota({
        flota: codigoFlota!,
        limite: 6,
        incluir_expirados: true
      });
      const fechaSelect = respFlota.data.find(e => e.fecha == fechaSelecionada);

      ///* Hora existe pero esta ocupado temporalmente

      /* const horaValid = fechaSelect?.horas.find(e => e.hora == hora);
      if (horaValid && horaValid.fecha_hora_limite != null) {
        const aux = horaValid.fecha_hora_limite.split(' ');
        if (calcularDiferenciaDeTiempo(horaActualSistema(), aux[1]) > 0) {
          return setAlert(
            true,
            texto.hora_ocupada,
            AlertSeverityEnum.info
          );
        }
      } */

      const resp = verificarHoras(fechaSelect?.horas!, hora);

      if (!resp.valido)

        return setAlert(
          true,
          texto.hora_min_planificacion,
          AlertSeverityEnum.info
        );

      set({ modal: true })
      set({ horasSelect: resp.arrayHoras })


      /* if (resp.idPreventa) {
        const respPre = await getPreagendamientos({
          preventa: resp.idPreventa
        });
        const firstElement = respPre.data.data.at(0);
        set({
          dataPreseleccionada: {
            celular: firstElement?.prospecto_data.celular!,
            estado_aceptacion: firstElement?.preventa_data.estado_aceptacion ? 'FIRMADO' : 'PENDIENTE FIRMAR',
            razon_social: cellLineaRazonSocial(firstElement?.contrato_data!, firstElement?.prospecto_data.razon_social!),
            identificacion: firstElement?.prospecto_data.identificacion!,
            fecha_hora_instalacion: `${firstElement?.fecha_instalacion} ${firstElement?.hora_instalacion}`
          }
        })
        set({ modalPreseleccionada: true })
      } else {
        set({ modal: true })
      }

      console.log(resp.arrayHoras); */


    } catch (error) {

    } finally {
      //set({ isLoadingPlanificacion: false })
    }

    /* ///* Hora esta bloqueado o no existe
    const resp = verificarHoras(fechaSelect?.horas!, hora);

    if (!resp.valido) return setAlert(
      true,
      texto.hora_min_planificacion,
      AlertSeverityEnum.info
    );

    

     */


  }
}));

export default useCalendarioInstalacionPyl;
